import { getOnlineNode } from "../../core/getNode";
import { apiEndpoints } from "../../config";
import { alertMessages } from "../alertMessages";

export function filterParams(entityFiltersReducer, path) {
  if (entityFiltersReducer.category && entityFiltersReducer.category !== 0) {
    path = path + "&category=" + entityFiltersReducer.category;
  }

  if (entityFiltersReducer.title && entityFiltersReducer.title !== "") {
    path = path + "&id_or_title=" + entityFiltersReducer.title;
  }

  if (entityFiltersReducer.author && entityFiltersReducer.author !== "") {
    if (typeof entityFiltersReducer.author === "string") {
      path = path + "&uid" + entityFiltersReducer.author;
    } else {
      if (entityFiltersReducer.author.value) {
        path = path + "&uid=" + entityFiltersReducer.author.value;
      }
    }
  }

  if (entityFiltersReducer.language && entityFiltersReducer.language !== 0) {
    path = path + "&language=" + entityFiltersReducer.language;
  }

  if (
    entityFiltersReducer.status &&
    entityFiltersReducer.status !== 0 &&
    entityFiltersReducer.status.length > 0
  ) {
    path = path + "&entity_status=" + entityFiltersReducer.status;
  }

  if (entityFiltersReducer.library && entityFiltersReducer.library !== 0) {
    path = path + "&library=" + entityFiltersReducer.library;
  }

  if (entityFiltersReducer.entityId && entityFiltersReducer.entityId !== "") {
    path = path + "&id_or_sita=" + entityFiltersReducer.entityId;
  }

  return path;
}

export function parseVocabularies(data, targetVid) {
  let newCategories = [
    {
      value: 0,
      label: "All Categories",
      has_content: true,
      has_view_permission: true,
    },
  ];
  let newLanguages = [{ value: 0, label: "All Languages" }];
  let newSitas = [{ value: "0", tid: "0", label: "NONE", title: "NONE" }];
  let newReferences = [{ value: "0", tid: "0", label: "NONE", title: "NONE" }];
  data.forEach((item) => {
    if (item.has_view_permission === true) {
      if (item.vid === targetVid) {
        newCategories.push({
          ...item,
          value: item.tid,
          label: item.title,
        });
      }

      if (item.vid === "language") {
        newLanguages.push({
          ...item,
          value: item.tid,
          label: item.title,
        });
      }

      if (item.vid === "sita") {
        newSitas.push({
          ...item,
          value: item.tid,
          label: item.title,
        });
      }

      if (item.vid === "reference") {
        newReferences.push({
          ...item,
          value: item.tid,
          label: item.title,
        });
      }
    }
  });
  return {
    categories: newCategories,
    languages: newLanguages,
    sitas: newSitas,
    references: newReferences,
  };
}

export function getEntityCategories({
  user,
  setCategories,
  setLanguages,
  setSitas,
  setReferences,
  _setError,
  targetVid,
}) {
  getOnlineNode(
    `${apiEndpoints.entityCategories}?vid=${targetVid},language,themes,sita,reference`,
    user.access_token,
  )
    .then((response) => {
      const parsedData = parseVocabularies(response.data, targetVid);
      if (setCategories) {
        setCategories(parsedData.categories);
      }
      if (setLanguages) {
        setLanguages(parsedData.languages);
      }
      if (setSitas) {
        setSitas(parsedData.sitas);
      }
      if (setReferences) {
        setReferences(parsedData.references);
      }
    })
    .catch((_error) => {
      if (_error.response) {
        _setError(true, _error.response.status, _error.response.statusText);
      } else if (_error.request) {
        //console.log('@rest request: ', _error.request);
        _setError(true, 0, alertMessages.requestError.message);
      } else {
        //console.log('@rest unknown: ', _error);
        _setError(true, 0, alertMessages.unkownError.message);
      }
    });
}

export function parseSummary(gridItem) {
  const summaryBlock =
    gridItem?.body?.blocks?.length > 0 &&
    gridItem.body.blocks.find((e) => e.type === "summary");

  const bodyBlock =
    gridItem?.body?.blocks?.length > 0 &&
    gridItem.body.blocks.find((e) => e.type === "body");
  if (summaryBlock) {
    return summaryBlock?.data?.text;
  } else if (bodyBlock) {
    return bodyBlock?.data?.text;
  }
}
